import { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import item from "../Datas/SidebarForRealWebsite.json";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-icons';
import './Sidebar.css';
import { getdata } from '../../Global/Index';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';

export default function Sidebar({ open = false, toggleSidebar }) {
  const [activeLinkId, setActiveLinkId] = useState(localStorage.getItem('activeLinkId') || "1");
  const [dropedownid, setDropedownid] = useState(JSON.parse(localStorage.getItem('dropedownid')) || []);
  const sidebarRef = useRef(null);
  const theme = useTheme();
  const [loanType, setLoanType] = useState(null);
  const [loanAccountNumber, setLoanAccountNumber] = useState(null);

  useEffect(() => {
    const getdatafunction = async () => {
      const data = await getdata();
      if (data.response.status === '200') {
        setLoanType(data.response.data.LoanType);
        setLoanAccountNumber(data.response.data.LoanAccountNumber);
      }
    }

    getdatafunction()
  }, [])



  const handleLinkClick = (id) => {
    setActiveLinkId(id);
    localStorage.setItem('activeLinkId', id);
    if (open) {
      toggleSidebar();
    }
  };


  const handleClickOutside = useCallback((event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target) && open) {
      toggleSidebar(false);
    }
  }, [open, toggleSidebar, sidebarRef]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, handleClickOutside]);


  useEffect(() => {
    localStorage.setItem('dropedownid', JSON.stringify(dropedownid));
  }, [dropedownid]);


  useEffect(() => {


    const savedActiveLinkId = localStorage.getItem('activeLinkId');
    const savedDropdownId = JSON.parse(localStorage.getItem('dropedownid')) || [];
    if (savedActiveLinkId) {
      setActiveLinkId(savedActiveLinkId);
    }
    if (savedDropdownId.length > 0) {
      setDropedownid(savedDropdownId);
    }

  }, []);



  return (
    <div>
      <div className={`sidebar ${open ? 'open' : ''}`} ref={sidebarRef} style={{ background: theme.palette.maincolor.sidebartheme, color: theme.palette.maincolor.light }}>
        <div className='logodashboard'></div>
        <div style={{ paddingLeft: '8px 15px' }} className="sidebar-item plain">{loanType}</div>
        <div className='accountnumber' style={{ background: theme.palette.maincolor.buttoncolor, color: theme.palette.maincolor.light }}>Loan Number : {loanAccountNumber}</div>
        <div className='buttondashboardleft'>
          <Link to="/dashboard" onClick={() => {
            handleLinkClick("1")
            localStorage.setItem('dropedownid', JSON.stringify([]));
          }} className={`sidebar-item plain ${activeLinkId === "0" ? 'active' : ''}`}>
            <i className="bi bi-person-fill" />Dashboard
          </Link>
        </div>
        {item?.map((item, index) => {
          if (item.childrens?.length > 0) {
            return (
              <div
                className={`sidebar-item ${dropedownid.includes(item.id) ? "open" : ""}`}
                key={index + 1000}
              >
                <button
                  className="sidebar-title"
                  onClick={() => {
                    setDropedownid(
                      dropedownid.includes(item.id)
                        ? dropedownid.filter((itemm) => itemm !== item.id)
                        : [...dropedownid, item.id]
                    );
                  }}
                >
                  <span>
                    {item.main_icon && <i className={item.main_icon}></i>}
                    <span>{item.title}</span>
                  </span>
                  <span className='toggle-btn'>
                    {item.icon && <i className={item.icon}></i>}
                  </span>
                </button>
                <div className="sidebar-content">
                  {item.childrens.map((child, index) => (
                    <Link
                      to={child.path || "#"}
                      className={`itemchild plain ${activeLinkId == child.id ? 'active' : ''}`}
                      key={child.id}
                      id={child.id}
                      onClick={() => handleLinkClick(child.id)}
                    >
                      {child.icon && <i className={child.icon}></i>}
                      {child.title}
                    </Link>
                  ))}
                </div>
              </div>
            );
          } else {
            return (
              <Link
                to={item.path || "#"}
                className={`sidebar-item plain ${activeLinkId == item.id ? 'active' : ''}`}
                key={item.id}
                id={item.id}
                onClick={() => handleLinkClick(item.id)}
              >
                {item.icon && <i className={item.icon}></i>}
                {item.title}
              </Link>
            );
          }
        })}
      </div>
      {open && <button className="overlay" onClick={() => toggleSidebar(false)} style={{ fontSize: '15px', backgroundColor: 'transparent', border: 'none' }}></button>}
    </div>


  );
}
// PropTypes validation
Sidebar.propTypes = {
  open: PropTypes.bool,
  toggleSidebar: PropTypes.func.isRequired,
};
